var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('the-layout-portal',[_c('v-container',{attrs:{"fluid":""}},[_c('ProfileCard',{attrs:{"user":_vm.User}}),_c('Debug',{attrs:{"debug":_vm.User}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }